import {Collection} from 'backbone';
import {collectionMixins} from '../../sinclair/sinclair.mixins';
import {bindAllMethods} from '../../backboneHelpers';

export default Collection.extend(
    Object.assign({}, collectionMixins.search, {
        initialize(searchOptions) {
            bindAllMethods(this);
            this.searchInitialize(searchOptions);
            this.setSearchType('package');
        },
    }),
);
